import { Observable, of, delay, BehaviorSubject } from "rxjs";
import { LoginResponse } from "../request-response/login-response";
import { GetCurrentUserResponse } from "../request-response/get-current-user-response";
import { UserModel } from "../models/user-model";
import AxiosService from "./axios-service";
import { map } from 'rxjs/operators';

const userChanged: BehaviorSubject<UserModel|undefined> = new BehaviorSubject<UserModel|undefined>(undefined);
export const user$ = (): Observable<UserModel|undefined> => userChanged.asObservable();



class AuthService {
    private user?:UserModel;
    
    private static instance: AuthService | null = null;

    private constructor() {
    }

    public static getInstance(): AuthService {
        if (this.instance === null) {
            this.instance = new AuthService();
        }
        return this.instance;
    }

    getCurrentUser():UserModel|undefined {
        return this.user;
    }

    getIsCurrentUserAdmin():boolean {
        if (!this.user) return false;
        return this.user!.roles.find(r=>r.name === 'admin') !== undefined;
    }

    login(email: string, password: string) : Observable<LoginResponse>  {
        return AxiosService.getInstance().post<LoginResponse>("/login", {email:email, password:password});
    };

    logout():Observable<void> {
        return AxiosService.getInstance().post<void>("/logout").pipe(
            map(()=> {
                this.user= undefined;
                userChanged.next(undefined);
            })
        );
    }

    getCurrentUserFromServer(): Observable<GetCurrentUserResponse> {
        return AxiosService.getInstance().get<GetCurrentUserResponse>("/api/users/current").pipe(
            map(userResponse=> {
                const user = userResponse.user;
                this.user = user;
                userChanged.next(user);
                return userResponse;
            })
        );
    };

}


export enum Roles {
    Admin = "admin",
    User = "user"
}


export default AuthService;